import { RetryValue } from 'react-query/types/core/retryer';

import { HttpStatusCode } from './statusCodes';
import { FetchError } from './fetchErrors';

// React Query only exposes RetryValue, so I attempt to extract ShouldRetryFunction from it
// https://github.com/TanStack/query/blob/v3/src/core/retryer.ts#L20
type ShouldRetryFunction<TError = unknown> = RetryValue<TError> extends number | boolean | infer OriginalShouldRetryFunction
  ? OriginalShouldRetryFunction
  : never;

interface MakeShouldRetryOptions {
  excludedStatusCodes: number[];
}

export const makeShouldRetry = <TError>({ excludedStatusCodes }: MakeShouldRetryOptions): ShouldRetryFunction<TError> => {
  return function shouldRetry(failureCount, error): boolean {
    if (error instanceof FetchError && excludedStatusCodes.includes(error.statusCode)) {
      return false;
    }

    // React Query v3 does not expose default shouldRetry or value of retry
    // https://github.com/TanStack/query/blob/v3/src/core/retryer.ts#L172-L182
    return failureCount < 3;
  };
};

export const shouldRetryExceptNotFound = makeShouldRetry({
  excludedStatusCodes: [HttpStatusCode.NotFound],
});
